import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-splashscreen',
  imports: [CommonModule],
  templateUrl: './splashscreen.html',
  styleUrl: './splashscreen.css'
})
export class Splashscreen implements OnInit, OnDestroy {
  show = true;
  private hideTimeout: any;

  ngOnInit(): void {
    // Dark Mode wird bereits in index.html initialisiert (inline Script)
    // Keine zusätzliche Initialisierung nötig

    // Splashscreen nach 2 Sekunden ausblenden
    this.hideTimeout = setTimeout(() => {
      this.show = false;
    }, 2000);
  }

  ngOnDestroy(): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }
}
